import React from 'react';
import CardBalanceDepositar from '../../../card/CardBalanceDepositar'

import Send from '../../../../assets/img/send/quicksend.png'
import Group from '../../../../assets/img/send/group.png'

const SelectSendBank = ({
    balanceBanck = 'Envía a una cuenta bancaria específica',
    balanceColurs = 'Envía a varias cuentas bancarias al mismo tiempo',

    labelBanck = "Envío Rápido",
    labelColurs = "Dispersión Múltiple",

    FastSendButton,
    GroupSendButton,
}) => {

    return (
        <>
            {< p className='w-full flex mt-4 text-base font-normal text-[#B7B7B9] traking-[-0.14px] leading-5 ' >Selecciona una opción para retirar </p >}

            <div className='w-full h-full flex items-center gap-2 justify-center py-4  ' >

                {<>
                    <CardBalanceDepositar icon={Send} balance={balanceBanck} hover={true} textBalance={'text-[14px]'} label={labelBanck} onClick={FastSendButton} />
                    <CardBalanceDepositar icon={Group} balance={balanceColurs} hover={true} textBalance={'text-[14px]'} label={labelColurs} onClick={GroupSendButton} />
                </>}
            </div>
        </>
    );
};

export default SelectSendBank; 